import React, { useState, useEffect } from 'react';
import '../styles/adminside.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import API_URL from "../config/api";

function Sidebar() {

  const [isSidebarClosed, setIsSidebarClosed] = useState(() => {
    const storedState = localStorage.getItem('sidebarClosed');
    return storedState ? JSON.parse(storedState) : false;
  });

  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [isNotifDropdownOpen, setIsNotifDropdownOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState(
    localStorage.getItem('alertMessage') || ''
  );

  const location = useLocation();
  const navigate = useNavigate();

  const currentPath = window.location.hash.replace("#", "");

  const user = JSON.parse(localStorage.getItem("user") || "null");

  const isAdmin = user?.role === 'admin';

    useEffect(() => {
        if (!user) return;
        fetchNotifications();
        const interval = setInterval(fetchNotifications, 5000);
        return () => clearInterval(interval);
    }, []);


    const fetchNotifications = async () => {
        try {
            if (!user) return;
                const response = await fetch(`${API_URL}/notification/get_notifications.php?user_id=${user.id}`
            );
            const data = await response.json();
            setNotifications(data);
            const unread = data.filter(
            notification => !notification.read
            ).length;
            setUnreadCount(unread);
        } catch (error) {
            console.error('Error fetching notifications:', error);
        }
    };

    const handleSidebarToggle = () => {
        setIsSidebarClosed(prev => {
            const value = !prev;
            localStorage.setItem("sidebarClosed", JSON.stringify(value));
            return value;
        });
    };

    const handleLogout = async () => {
        try {
            // await fetch("http://localhost/arboreatrix_backend/auth/logout.php");
        } catch (error) {
            console.error(error);
        }
        localStorage.removeItem("user");
        localStorage.removeItem("sidebarClosed");
        localStorage.removeItem("alertMessage");
        navigate("/AuthPage", { replace: true });
    };

    const markAsRead = async () => {
        try {
            const response = await fetch(`${API_URL}/notification/mark_notifications_read.php`,
            {
                method: "POST",
                headers: {
                "Content-Type": "application/json"
                },
                body: JSON.stringify({
                user_id: user.id
                })
            }
            );
            const result = await response.json();
            if (result.success) {
            setUnreadCount(0);
            setAlertMessage("");
            fetchNotifications();
            }
        }
        catch (error) {
            console.error("Error marking notifications:", error);
        }
    };

  const toggleNotifDropdown = () => {
    setIsNotifDropdownOpen(!isNotifDropdownOpen);
  };

    const removeAlert = async (indexToRemove) => {
        try {
            const notification = notifications[indexToRemove];
            if (!notification) return;
            await fetch(`${API_URL}/notification/delete_notification.php`,
            {
                method: "POST",
                headers: {
                "Content-Type": "application/json"
                },
                body: JSON.stringify({
                id: notification.id
                })
            }
            );
            fetchNotifications();
        }
        catch (error) {
            console.error("Error deleting notification:", error);
        }
    };
  
  
  
  const hasUnreadNotifications = unreadCount > 0 || alertMessage;

  function MenuItem({ to, label, iconClass }) {
    const isActive =
    currentPath === to ||
    currentPath.startsWith(to + "?");

    return (
      <li className={isActive? 'active' : ''} key={to}>
        <Link to={to}>
          <i className={`bx ${iconClass}`}></i>
          {label}
        </Link>
      </li>
    );
  }

    return (
        <>
            <div className={`sidebar ${isSidebarClosed ? "open" : ""}`}>
            <Link to="/Home" className="logos">
                <img
                src="/img/arbologo.png"
                alt="Logo"
                className="icon"
                style={{ width: "60px", padding: "10px" }}
                />
                <div className="logo_name">ARBOREATRIX</div>
            </Link>

            <ul className="side-menu">
                <MenuItem
                to="/Home"
                label="Home"
                iconClass="bxs-dashboard"
                />

                <MenuItem
                to="/Tree"
                label="Trees"
                iconClass="bx bxs-tree"
                />

                <MenuItem
                to="/AdminPinStatus"
                label="Status"
                iconClass="bx bxs-objects-vertical-bottom"
                />

                <MenuItem
                to="/AdminMap"
                label="Map"
                iconClass="bx bx-map-alt"
                />

                <MenuItem
                to="/AdminUserList"
                label="Users"
                iconClass="bx bx-user-circle"
                />

                <MenuItem
                to="/AdminReport"
                label="Reports"
                iconClass="bx bxs-report"
                />

                <MenuItem
                to="/AdminFeedback"
                label="Feedback"
                iconClass="bx bxs-comment"
                />

                <MenuItem
                to="/AdminFaqs"
                label="Faqs"
                iconClass="bx bxs-bulb"
                />
            </ul>
            </div>

            <div className="content" id="sidecontent">
            <nav>

                <form action="#">
                <div className="form-input">
                    <i
                    className={
                        isSidebarClosed
                        ? "bx bx-menu"
                        : "bx bx-x"
                    }
                    onClick={handleSidebarToggle}
                    style={{ cursor: "pointer" }}
                    ></i>
                </div>
                </form>

                <div className="notif">

                <i
                    className="bx bx-bell"
                    onClick={toggleNotifDropdown}
                ></i>

                {hasUnreadNotifications && (
                    <span
                    className={`dot ${
                        unreadCount === 0 ? "hide-dot" : ""
                    }`}
                    ></span>
                )}

                {isNotifDropdownOpen && (

                    <div className="notif-dropdown show">

                    {notifications.length > 0 ? (

                        <>
                        <ul>

                            {notifications.map((notif, index) => (

                            <li
                                key={notif.id ?? index}
                                className={notif.read ? "" : "unread"}
                                style={{
                                border: "1px solid #ccc",
                                padding: "5px",
                                margin: "5px",
                                backgroundColor: "#4CAF50",
                                position: "relative"
                                }}
                            >

                                {notif.message}

                                <button
                                onClick={() => removeAlert(index)}
                                style={{
                                    position: "absolute",
                                    right: "5px",
                                    top: "5px",
                                    border: "none",
                                    background: "transparent",
                                    cursor: "pointer",
                                    color: "#fff",
                                    fontWeight: "bold"
                                }}
                                >
                                ×
                                </button>

                            </li>

                            ))}

                        </ul>

                        <button
                            onClick={markAsRead}
                            className="mark-read-btn"
                        >
                            Mark all as read
                        </button>

                        </>

                    ) : (

                        <p>No new notifications</p>

                    )}

                    </div>

                )}

                </div>

                <div className="profile">

                    <button
                        type="button"
                        onClick={handleLogout}
                        className="logout"
                        style={{
                            border: "none",
                            background: "transparent",
                            cursor: "pointer",
                            padding: 0
                        }}
                    >
                        <i className="bx bx-log-out-circle"></i>
                    </button>

                </div>

            </nav>
            </div>
        </>
    );
}

export default Sidebar;